import { useEffect } from "react";

const NOMBRE_BASE = "Colegio William C. Morris";

// Al ser una SPA, todas las rutas comparten el <title> de index.html: Google
// indexa "Inicial", "Primario" y "Contacto" con el mismo título y no las
// distingue. Este hook lo actualiza al entrar a cada página.
export default function useTituloPagina(titulo, descripcion) {
  useEffect(() => {
    document.title = titulo ? `${titulo} | ${NOMBRE_BASE}` : NOMBRE_BASE;

    if (descripcion) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", descripcion);
    }
  }, [titulo, descripcion]);
}
